import api from "@/libs/axios";
import * as ep from "../../../../endpoints";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { hasError } from "@/utils/utils";
export default {
  namespaced: true,
  state: {
    parmassins: {},
    transictionRole :{},
    loadingParmassins: false,
    loadingTransictionRole: false,
    working: false,
  },
  getters: {
    parmassins(state) {
      return state.parmassins;
    },
    loadingParmassins(state) {
      return state.loadingParmassins;
    },
    
    loadingTransictionRole(state) {
      return state.loadingTransictionRole;
    },
    working(state) {
      return state.working;
    },
    transictionRole(state){
      return state.transictionRole;
    }
  },
  mutations: {
    setParmassins(state, payload) {
      state.parmassins = payload;
    },
    setWorking(state, payload) {
      state.working = payload;
    },
    setTransictionRole(state, payload) {
      state.transictionRole = payload;
    },
  },
  actions: {
    async updateUserVvailability({ commit }, payload) {
      let is_online = payload.is_online == '1' ? '0' : '1'
      console.log("payload" , payload)
      var req = new FormData();
      req.append('is_online', is_online);
      req.append("_method", "PUT");
      commit("setWorking", true);
      try {
        const res = await api.post(ep.UPDATE_USER_AVAILABILITY_BY_ID(payload.id), req);
        if (hasError(res.status)) {
          throw res.status;
        }
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم تغيير حالة المستخدم بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
        return Promise.resolve();
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
        return Promise.reject();
      } finally {
        commit("setWorking", false);
      }
    },
  },
};
